import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

const AuthCallback: React.FC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get the session from the URL
        const {
          data: { session },
          error,
        } = await supabase.auth.getSession()

        if (error) {
          console.error('Auth callback error:', error)
          navigate('/auth')
          return
        }

        if (session) {
          // Successfully authenticated, redirect to dashboard
          navigate('/dashboard')
        } else {
          // No session, redirect to auth page
          navigate('/auth')
        }
      } catch (error) {
        console.error('Unexpected error during auth callback:', error)
        navigate('/auth')
      }
    }

    handleCallback()
  }, [navigate])

  return (
    <div className="auth-loading">
      <div className="auth-loading-spinner"></div>
      <p>Completing authentication...</p>
    </div>
  )
}

export default AuthCallback
